import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconFlowConnectorEndPoint({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} d="M12 12a3 3 0 1 0-2.83-4H4a1 1 0 0 0 0 2h5.17A3.001 3.001 0 0 0 12 12z"/>
        </svg>
    );
}

export default IconFlowConnectorEndPoint;
